import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let treatment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'treatment_id',
  })

  return {
    variables: { treatment_id },
    pause: !treatment_id,
    requestPolicy: 'cache-and-network',
  }
}
